import { render, staticRenderFns } from "./Formulario060.vue?vue&type=template&id=6aa5c2d8"
import script from "./Formulario060.vue?vue&type=script&lang=js"
export * from "./Formulario060.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports